export const selectVisitorsState = state => state.findAndFilterData.visitors.data;